import AMAPage from './AMAPage'

export default AMAPage
// eslint-disable-next-line import/export
export * from './AMAPage'
